import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  IFilters2,
  getDefaultFormValuesAndFormFields
} from 'src/components/filters';
import { toFormFields2 } from 'src/lib';
import {
  getFilterFields2,
  getFilterFieldsForScenarioManager
} from '../api/filter-api';

const transformResponseToFormMetadata = (response: IFilters2) => {
  const { combinations, filters } = response;
  const formFields = toFormFields2(filters);
  const initialFormValues = formFields.reduce(
    (prev, curr) => ({ ...prev, [curr.name]: curr.default_value }),
    {}
  );
  const { newFormValues, formFieldsWithUpdatedOptions } =
    getDefaultFormValuesAndFormFields(
      formFields,
      combinations,
      initialFormValues
    );
  return {
    newFormValues,
    formFieldsWithUpdatedOptions,
    combinations
  };
};

export const fetchFilterFields = createAsyncThunk(
  '/api/filters/getFilterFields',
  async (args: { sourceId: number; moduleId: number; scenarioId: number }) => {
    const response = await getFilterFields2(
      args.sourceId,
      args.moduleId,
      args.scenarioId
    );
    return transformResponseToFormMetadata(response);
  }
);

export const fetchFilterFieldsForScenarioManager = createAsyncThunk(
  '/api/filters/getFilterFields',
  async (args: { sourceId: number }) => {
    const response = await getFilterFieldsForScenarioManager(args.sourceId);
    return transformResponseToFormMetadata(response);
  }
);
